<style scoped>
.forgot-container {
	max-width: 500px;
	margin: 0 auto;
}
.forgot-box {
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	overflow: hidden;
	padding: 40px;
}
.forgot-header {
	margin-bottom: 25px;
	text-align: center;
}
</style>

<template>
	<div
		class="container min-vh-100 d-flex align-items-center justify-content-center py-5"
	>
		<div class="forgot-container">
			<div class="forgot-box">
				<div class="forgot-header">
					<h2>Reset Password</h2>
					<p class="text-muted">Enter your username or email to receive a reset link</p>
				</div>

				<div v-if="!submitted">
					<div v-if="error" class="alert alert-danger" role="alert">
						{{ error }}
					</div>

					<form @submit.prevent="handleSubmit">
						<div class="mb-3">
							<label for="identifier" class="form-label">Email or Username</label>
							<input
								type="text"
								class="form-control"
								id="identifier"
								v-model="identifier"
								placeholder="your@email.com or username"
								required
								:disabled="loading"
							/>
						</div>

						<div class="d-grid gap-2">
							<ButtonLoading
								:loading="loading"
								text="Send Reset Link"
								variant="primary"
								type="submit"
							/>
						</div>

						<div class="mt-3 text-center">
							<p><RouterLink to="/signin">Back to Login</RouterLink></p>
						</div>
					</form>
				</div>

				<div v-else>
					<div class="alert alert-success" role="alert">
						If that account exists, a password reset link has been sent to the registered email address.
					</div>
					<div class="text-center mt-3">
						<RouterLink to="/signin" class="btn btn-primary">Back to Login</RouterLink>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { apiClient } from "@/client";
import ButtonLoading from "@/components/common/ButtonLoading.vue";

const identifier = ref("");
const loading = ref(false);
const error = ref("");
const submitted = ref(false);

async function handleSubmit() {
	if (!identifier.value) {
		error.value = "Please enter your email or username.";
		return;
	}

	loading.value = true;
	error.value = "";

	try {
		const payload: Record<string, string> = {};
		if (identifier.value.includes("@")) {
			payload.email = identifier.value;
		} else {
			payload.username = identifier.value;
		}
		await apiClient.JSONPost("/api/password-reset/request", payload);
	} catch {
		// Always show success regardless of response
	} finally {
		loading.value = false;
		submitted.value = true;
	}
}
</script>
